import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BaseComponent } from '../../../core/components/base.component';
import { Lookup } from '../../../vas/business-objects/lookup/lookup.model';
import { VasAppFacade } from '../../../vas/services/vas-app-facade.service';

@Component({
    selector: 'vas-text-block-picker',
    templateUrl: 'text-block-picker.component.html'
})
export class TextBlockPickerComponent extends BaseComponent {
    @Input() lookupTypeId: string;
    @Output() pickItem = new EventEmitter<Lookup>();

    SEARCH_DELAY = 300;
    SEARCH_MIN_LENGTH = 3;
    MAX_RESULTS = 5;
    showAll = false;

    term$ = new BehaviorSubject<string>(undefined);
    results: Array<Lookup> = [];
    notShownCount = 0;

    constructor(
        protected appFacade: VasAppFacade
    ) {
        super();

        this.term$
            .debounceTime(this.SEARCH_DELAY)
            .filter(term => term && (
                term === '*' ||
                term.length >= this.SEARCH_MIN_LENGTH
            ))
            .concatMap(term =>
                this.appFacade.objects.lookup.store.getBy(
                    lookup =>
                        lookup.lookupType === this.lookupTypeId &&
                        (
                            term === '*' ||
                            lookup.title.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) !== -1 ||
                            lookup.content.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) !== -1
                        )
                ).take(1)
            )
            .map(lookups => lookups.sort((a, b) => a.title.localeCompare(b.title)))
            .map(lookups => {

                if (this.showAll) {
                    return lookups;
                }

                this.notShownCount = Math.max(lookups.length - this.MAX_RESULTS, 0);

                return lookups.slice(0, this.MAX_RESULTS);
            })
            .takeUntil(this.ngUnsubscribe)
            .subscribe(lookups => this.results = lookups);
    }

    onKeyUp(event: KeyboardEvent): void {

        const term = (event.srcElement as HTMLInputElement).value;

        if (!term || term.length === 0) {
            this.onReset();
            return;
        }

        this.showAll = false;
        this.term$.next(term);
    }

    onPick(item: Lookup): void {
        this.pickItem.next(item);
    }

    onReset(): void {
        this.results.length = 0;
        this.showAll = false;
    }

    onShowAll(): void {
        this.showAll = true;
        this.term$.next('*');
    }
}



// WEBPACK FOOTER //
// ./src/app/atoms/text-block-picker/text-block-picker.component.ts